import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { foreignRoleRedirect } from './role-areas';

/**
 * Protege /collaborator. Requiere una sesión con rol "colaborador".
 *
 * A diferencia de los guards del socio, no consulta `computeEffectiveStatus`: un
 * colaborador no recorre la máquina de cuatro estados. Su cuenta nace verificada y
 * en `approved` porque la creó el backend tras validar el token de invitación, así
 * que no hay onboarding que esperar.
 */
export const collaboratorGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/']);
          const away = foreignRoleRedirect(router, status.role, ['colaborador']);
          if (away) return away;
          return true;
        }),
      );
    }),
  );
};
